import React from 'react';

import { Card, Button } from '../components/ui';
import { useOnboarding } from '../contexts/Onboarding';
import { ProgressRing } from './ProgressRing';
import './setup-summary.scss';

/**
 * The permanent way back into the setup checklist.
 *
 * The floating widget can be dismissed, and dismissal is stored per store — so
 * without this row, closing it once removed the only route to the remaining
 * steps for good. This lives on Settings and never disappears: it reports
 * progress, reopens the panel, and restores it if it was dismissed.
 *
 * Renders nothing when the endpoint is unavailable, matching the widget: a
 * setup nudge should never leave a broken card on someone's settings page.
 */
export function SetupSummaryCard() {
  const { available, dismissed, done, total, complete, setOpen, restore } = useOnboarding();

  if (!available || total === 0) return null;

  const reopen = () => {
    if (dismissed) restore();
    setOpen(true);
  };

  return (
    <Card className="rc-setup-summary">
      <ProgressRing value={done} total={total} size={40} />

      <div className="rc-setup-summary__text">
        <h3 className="rc-setup-summary__title">Store setup</h3>
        <p className="rc-setup-summary__sub">
          {complete
            ? 'Everything on the list is done.'
            : `${done} of ${total} steps complete${dismissed ? ' · hidden from your sidebar' : ''}`}
        </p>
      </div>

      <Button variant={complete ? 'outline' : 'primary'} size="lg" onClick={reopen}>
        {dismissed ? 'Show setup again' : 'Open setup'}
      </Button>
    </Card>
  );
}

export default SetupSummaryCard;
